<div class="content">
  <div class="header">
    <div class="pos-heading" *ngIf="title.length > 0">
      <rpe-ui-button [bg_blue]="true" icon="arrow_back" (onClick)="goBack()">Volver</rpe-ui-button>
      <div class="title">
        <p>{{ title }}</p>
      </div>
    </div>
  </div>
  <div class="body">
    <div class="content">
      <ng-content select="[slot=content]"></ng-content>
    </div>
  </div>
</div>